module.exports = __webpack_public_path__ + "img/wallet_mb_01.09626529.png";